import { ColumnElement, ColumnTitle } from '@atoms/columnElement';
import { InfoTooltip } from '@atoms/infoTooltip';
import { SwitchV2 } from '@atoms/switch';
import { Column } from '@components/dnd/base/blockBase/body.block.style';
import { Input } from '@components/ui/input';
import { Label } from '@components/ui/label';
import type { AtomModel } from '@models/atom.model';
import type { TextData } from '@stratumn/studio-shared';
import type { PropsWithChildren } from 'react';

type Props = Omit<TextData, 'type'> & {
  onDefaultChange: (value: TextData['default']) => void;
  onIsRichTextChange: (value: TextData['isRichText']) => void;

  atomId: AtomModel['id'];
};

export const TextWidget = (props: PropsWithChildren<Props>) => {
  const onDefaultValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (!value) {
      props.onDefaultChange(undefined);
      return;
    }
    props.onDefaultChange(value);
  };
  return (
    <>
      {props.children}

      <Column $width="200px">
        <ColumnTitle>Display options</ColumnTitle>

        <ColumnElement>
          <div className="flex items-center gap-2">
            <Label htmlFor={`default-${props.atomId}`}>Default value</Label>
            <InfoTooltip
              description="If no data is found, this value will be the default one. Empty by default."
              title="Default value"
            />
          </div>
          <Input
            id={`default-${props.atomId}`}
            onChange={onDefaultValueChange}
            placeholder="Aa"
            value={props.default}
          />
        </ColumnElement>
        <ColumnElement>
          <SwitchV2
            checked={props.isRichText}
            id={`is-rich-text-${props.atomId}`}
            labelText="Is rich text data"
            onCheckedChange={isRichTest => props.onIsRichTextChange(isRichTest)}
            tooltip={
              <InfoTooltip
                description="If the data is a rich text (bold, italic etc.), this option needs to be enabled."
                title="Rich text data"
              />
            }
          />
        </ColumnElement>
      </Column>
    </>
  );
};
